import { Alert, Box, Divider, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/state/UsersAction";
import * as modalActions from "../modalActionTypes";
import { grey } from "@mui/material/colors";
import { getErrorMessage } from "common/utils/Helper";

export default function ConfirmUser({ setOpen, userId, setUserId, setAction }) {
  const dispatch = useDispatch();

  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  useEffect(() => {
    dispatch(actions.editUser(userId));
  }, []);

  const user = useSelector((state) => state?.users?.user);
  const userErrorStatus = useSelector((state) => state?.users?.error?.response?.status);

  const closeModal = () => {
    setAction(modalActions.ADD);
    setUserId("");
    setOpen(false);
  };

  const onSubmit = (values) => {
    const request = {
      payload: values,
      successCallBack: (response) => {
        closeErrorSB()
        closeModal();
        dispatch(actions.getUsers());
        console.log("response", response);
      },
      failCallBack: (error) => {
        console.log("error", error);
        setErrorMessage(getErrorMessage(error, userErrorStatus))
        openErrorSB();
      },
    };
    dispatch(actions.deleteUser(request));
  };

  // const navigate = useNavigate();
  const { handleSubmit, touched } = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: user?.id,
      // username: user?.username,
    },
    onSubmit,
  });
  return (
    <MDBox my={1}>
      {errorSB && (
        <Typography textAlign="center" color="error" variant="body2">
          {errorMessage} {" < Echec de suppresion >"}
        </Typography>
      )}
      <form onSubmit={handleSubmit}>
        <MDBox py={1}>
          <Alert severity="error">Etes vous sure de vouloir supprimer - {user?.username}</Alert>
        </MDBox>
        <Divider />
        <Box mt={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Box mr={1}>
            <MDButton type="submit" variant="contained" size="small" color="error">
              Supprimer
            </MDButton>
          </Box>
          <Box mr={1}>
            <MDButton
              size="small"
              onClick={closeModal}
              style={{ background: grey[500], color: "white" }}
            >
              Annuler
            </MDButton>
          </Box>
        </Box>
      </form>
    </MDBox>
  );
}
